<template>
  <div class="core_wrap">
    <div class="core_title">优质的服务来自技术核心驱动</div>
    <el-row class="core_options" type="flex" justify="space-between">
      <el-col class="core_items hidden-xs-only" v-for="(item, index) in coresList" :key="index"
        :class="item.isActive ? 'is_active' : ''" @click.native="changeCurrentIndex(index)">{{ item.title }}</el-col>
      <el-col class="core_items2 hidden-sm-and-up" v-for="(item, index) in coresList" :key="item.tit"
        :class="item.isActive ? 'is_active' : ''" @click.native="changeCurrentIndex(index)">{{ item.title }}</el-col>
    </el-row>
    <component :is="currentComponent[currentIndex]" :core="coresList[currentIndex] || {}"></component>
  </div>
</template>

<script>
import CoreItemOne from './CoreItemOne.vue'
import CoreItemTwo from './CoreItemTwo.vue'
import CoreItemThree from './CoreItemThree.vue'
import Constant from '@/utils/Constant'
import { leftLikeDict } from '../../api/system';
import { findMainProp, findMainPropArr, transDictData, transDictDataNotType, transDictDataNotTypeMore } from '../../utils';
export default {
  data() {
    return {
      coresList: [],
      currentIndex: 0,
      currentComponent: [CoreItemOne, CoreItemTwo, CoreItemThree]
    }
  },
  methods: {
    changeCurrentIndex(index) {
      this.currentIndex = index
      this.coresList.map((v, i) => {
        i === index ? (v.isActive = true) : (v.isActive = false)
      })
    },
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.HOME4);
      if (res.data) {
        const back = findMainPropArr(res.data.data, Constant.HOME4)
        back.map((v, i) => {
          let transData
          if (i <= 1) {
            transData = transDictDataNotType(res.data.data.find(v => v.dictKey === `home4Title${i + 1}`).children, `home4Title${i + 1}Content`)
          } else {
            transData = transDictDataNotTypeMore(res.data.data.find(v => v.dictKey === `home4Title${i + 1}`).children, `home4Title${i + 1}Content`)
          }
          this.coresList.push({
            title: v.title,
            subTitle: v.subtitle,
            desc: v.desc,
            isActive: i === 0,
            children: transData,
            image: v.image
          })
        })
      }
    }
  },
  mounted() {
    this.leftLikeDictFunc()
  }
}
</script>

<style lang="scss" scoped>
.core_wrap {
  width: 100%;
  padding: 100px 0;
  text-align: center;

  .core_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;

    @media screen and (max-width: 768px) {
      font-size: 1.6rem;
      padding: 20px 15px;
      line-height: 1.4;
    }
  }

  .core_options {
    width: 70%;
    margin: 0 auto;

    @media screen and (max-width: 768px) {
      width: 95%;
      gap: 8px;
      margin-bottom: 10px;
    }

    .core_items {
      width: 30%;
      height: 70px;
      border: solid 1px #04cac7;
      font-size: 30px;
      line-height: 70px;
      user-select: none;
      cursor: pointer;
      margin-bottom: 40px;
    }

    .core_items2 {
      width: 30%;
      height: 100PX;
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px #04cac7;
      padding: 5PX;
      font-size: 0.9rem;

      @media screen and (max-width: 768px) {
        height: 55px;
        font-size: 0.95rem;
        border-radius: 8px;
        padding: 0 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .is_active {
      color: #fff;
      font-weight: bold;
      background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
      box-shadow: 0 0.5rem 1.5rem 0 rgb(0 135 168 / 50%);

      @media screen and (max-width: 768px) {
        box-shadow: 0 0.3rem 1rem 0 rgb(0 135 168 / 40%);
        border: none;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .core_wrap {
    padding: 10px 0;
  }
}
</style>